// ローカル実行時に使うデモ用データ
import type { Categories, Comments, Messages, Topics } from "@/model";

const categories: Categories = [];
const topics: Topics = [];
const messages: Messages = {};
const comments: Comments = {};

export { categories, topics, messages, comments };

/** デモデータの登録作業 */
export async function registerDemoData(
  _type: "category" | "topic" | "message" | "comment",
): Promise<void> {
  // 空
}
